import { useCallback } from 'react';
import debounce from "lodash.debounce";

export const useDebouncedCallback = (callback, delay) => {
  return useCallback(debounce(callback, delay), [callback, delay]);
};
